/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-promise-reject-errors */
import store from '@carvana/purchase-store';
import { saveAs } from 'file-saver';
import { PDFDocument } from 'pdf-lib';
import * as Services from '../services';
import {
  CONTRACTS_FETCH,
  CONTRACTS_DOWNLOAD,
  INITIATE_CONTRACTS_FETCH,
  ORDER_OPTIONS_FETCH,
  SEND_CO_BUYER_EMAIL,
  SET_CONTRACTS_TOAST,
  RESET_CONTRACTS_TOAST
} from './actionTypes';

export const InitiateFetchContracts = () =>
  store.dispatch({
    type: INITIATE_CONTRACTS_FETCH
  });

export const FetchContracts = () => dispatch =>
  dispatch({
    type: CONTRACTS_FETCH,
    async payload() {
      return Services.fetchContracts();
    }
  });

export const DownloadContracts = () => dispatch =>
  dispatch({
    type: CONTRACTS_DOWNLOAD,
    async payload() {
      const isBlobSupported = () => {
        try {
          return !!new Blob();
        } catch (e) {
          return false;
        }
      };

      if (!isBlobSupported()) {
        return Promise.reject('Unable to download contracts');
      }

      try {
        const docuSignEnvelopeId = await Services.fetchContracts(true).then(
          res => res.docuSignEnvelopeId
        );

        const contracts = await Services.downloadContracts(docuSignEnvelopeId);

        const { content } = contracts;

        const contractsPdf = await PDFDocument.create();

        for (const documentBase64 of Object.values(content)) {
          const pdfDocument = await PDFDocument.load(documentBase64);

          // eslint-disable-next-line no-await-in-loop
          const newPages = await contractsPdf.copyPages(
            pdfDocument,
            Array.from(Array(pdfDocument.getPageCount()).keys())
          );

          newPages.forEach(page => contractsPdf.addPage(page));
        }

        const pdfBytes = await contractsPdf.save();

        const blob = new Blob([pdfBytes], {
          type: 'application/pdf'
        });
        const filename = 'contracts.pdf';

        saveAs(blob, filename);

        return Promise.resolve();
      } catch (error) {
        return Promise.reject('Unable to download contracts');
      }
    }
  });

  export const SetToastMessage = payload => dispatch =>
    dispatch({
      type: SET_CONTRACTS_TOAST,
      payload
    });

export const ResetToastMessage = () => dispatch =>
  dispatch({
    type: RESET_CONTRACTS_TOAST
  });

export const SendCoBuyerEmail = () => dispatch =>
  dispatch({
    type: SEND_CO_BUYER_EMAIL,
    async payload() {
      return Services.sendCoBuyerEmail();
    }
  }).then(() => {
    const message = {
      type: 'success',
      message: 'Contract successfully sent',
      subMessage:
        'Your cosigner will receive an email with their contract included.'
    };
    return dispatch(SetToastMessage(message));
  });

export const FetchOrderOptions = () =>
  store.dispatch({
    type: ORDER_OPTIONS_FETCH,
    payload: Services.fetchOrderOptions()
  });

export const FetchAndSendCoBuyerEmail = () => (dispatch, getState) => {
  const {
    orderPlaced: {
      contracts: { contractsStatus }
    }
  } = getState();

  if (!contractsStatus || contractsStatus.length === 0) {
    return Promise.resolve(
      dispatch(FetchContracts()).then(() => dispatch(SendCoBuyerEmail()))
    );
  }

  return Promise.resolve(dispatch(SendCoBuyerEmail()));
};
